import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { AddonTemplateInterface } from "../../store/mine_craft/addonTemplatesSlice";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.addonTemplatePath(value.id),
    thumbnail_url: minecraftUrls.remoteUrl(value.thumbnail_url),
    mcpack_url: minecraftUrls.remoteUrl(value.mcpack_url),
    mcpack_second_url: minecraftUrls.remoteUrl(value.mcpack_second_url)
  };
}

const addonTemplatesEntity = new schema.Entity(
  'addon_templates',
  {},
  {
    processStrategy
  }
);

const addonTemplateEntity = new schema.Entity(
  'addon_template',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { addon_template: AddonTemplateInterface }>(response.data.addon_template, addonTemplateEntity);
  return normalized.entities;
}

export const fetchAddonTemplates = createAsyncThunk(
  'addonTemplates/fetchAddonTemplates',
  async (params: object = {}) => {
    const response    = await mineCraftApi.get(`/onesky/addon_templates`, { params })
    const normalized  = normalize<any, { addon_templates: { [key: string]: AddonTemplateInterface } }>(response.data.addon_templates, [addonTemplatesEntity]);

    return {
      addon_templates: normalized.entities?.addon_templates || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchAddonTemplate = createAsyncThunk(
  'addonTemplates/fetchAddonTemplate',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/addon_templates/${id}`);
    return normalizeInstance(response);
  }
);

export const createAddonTemplate = createAsyncThunk(
  'addonTemplates/createAddonTemplate',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post(`/onesky/addon_templates`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateAddonTemplate = createAsyncThunk(
  'addonTemplates/updateAddonTemplate',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/addon_templates/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyAddonTemplate = createAsyncThunk(
  'addonTemplates/destroyAddonTemplate',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/addon_templates/${id}`);
    return response.data;
  }
);
